import Vue from "vue";

export default function () {
    window.Vue = Vue;
}
